import { useTranslation } from 'react-i18next';
import { capitalizeSign } from './chartViewAdapter';
import { signLabel } from './chartViewHelpers';
import styles from './Big3Strip.module.css';

export interface Big3StripProps {
  sun: string;
  moon: string;
  ascendant: string;
  'data-testid'?: string;
}

export function Big3Strip(props: Big3StripProps): JSX.Element {
  const { t } = useTranslation('me');
  const items = [
    { sym: '☉', label: t('big3.sun'), val: signLabel(capitalizeSign(props.sun), t) },
    { sym: '☾', label: t('big3.moon'), val: signLabel(capitalizeSign(props.moon), t) },
    { sym: 'AC', label: t('big3.rising'), val: signLabel(capitalizeSign(props.ascendant), t) },
  ] as const;

  return (
    <div className={styles.strip} data-testid={props['data-testid'] ?? 'me-big3-strip'}>
      {items.map((b, i) => (
        <div key={b.label} className={i > 0 ? styles.cellDivided : styles.cell}>
          <span className={styles.sym}>{b.sym}</span>
          <span className={styles.label}>{b.label}</span>
          <span className={styles.val}>{b.val}</span>
        </div>
      ))}
    </div>
  );
}
